/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_Import_RunInputs */



/**
* | output |
* | --- |
* | "Add {count} member(s)" |
*
* @param {Team_Manager_Import_RunInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_run = /** @type {((inputs: Team_Manager_Import_RunInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_RunInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ajouter ${i?.count} membre(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Mitglied(er) hinzufügen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiungi ${i?.count} membro/i`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Добавить участников: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Añadir ${i?.count} miembro(s)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`添加 ${i?.count} 位成员`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 人を追加`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} सदस्य जोड़ें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Adicionar ${i?.count} membro(s)`)
	return /** @type {LocalizedString} */ (`Add ${i?.count} member(s)`)
});